window._loadedComponents = window._loadedComponents || new Set();

async function themeComponent(url, isAsync = false, checkDom = false) {
  if (!url || window._loadedComponents.has(url)) return;

  const tagName = url.replace(/.*\//, '').replace(/\?.*/, '').replace('cmp-', '').replace('res-', '').replace('.js', '');
  const className = tagName
    .replace(/-([a-z])/g, (g) => g[1].toUpperCase())
    .replace(/^./, (g) => g.toUpperCase());

  if (window[className] !== undefined || customElements.get(tagName)) {
    window._loadedComponents.add(url); // still mark it so we don't re-check later
    return;
  }

  if (checkDom && document.querySelector(tagName) === null) {
    return;
  }

  try {
    if (isAsync) {
      import(url).then(() => window._loadedComponents.add(url));
    } else {
      await import(url);
      window._loadedComponents.add(url);
    }
  } catch (e) {
    console.error(`Errore nel caricamento del componente ${tagName}:`, e);
  }
}

window.themeComponent = themeComponent;


// Create a global tracker if it doesn't exist
window._loadedResources = window._loadedResources || new Set();

async function themeResource(url) {
  if (!url) return;

  if (window._loadedResources.has(url)) {
    // Already imported this thing
    return;
  }

  try {
    await import(url);
    window._loadedResources.add(url); // Mark as loaded
  } catch (e) {
    console.error(`Errore nel caricamento della risorsa: ${url}`, e);
  }
}

window.themeResource = themeResource;

// attivo i popover di bootstrap
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
